var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0833 17.4167H20.5833V7.91671C20.5833 7.49678 20.4165 7.09405 20.1196 6.79712C19.8226 6.50019 19.4199 6.33337 19 6.33337C18.5801 6.33337 18.1773 6.50019 17.8804 6.79712C17.5835 7.09405 17.4167 7.49678 17.4167 7.91671V17.4167H7.91666C7.49674 17.4167 7.09401 17.5835 6.79708 17.8805C6.50014 18.1774 6.33333 18.5801 6.33333 19C6.33333 19.42 6.50014 19.8227 6.79708 20.1196C7.09401 20.4166 7.49674 20.5834 7.91666 20.5834H17.4167V30.0834C17.4167 30.5033 17.5835 30.906 17.8804 31.203C18.1773 31.4999 18.5801 31.6667 19 31.6667C19.4199 31.6667 19.8226 31.4999 20.1196 31.203C20.4165 30.906 20.5833 30.5033 20.5833 30.0834V20.5834H30.0833C30.5033 20.5834 30.906 20.4166 31.2029 20.1196C31.4998 19.8227 31.6667 19.42 31.6667 19C31.6667 18.5801 31.4998 18.1774 31.2029 17.8805C30.906 17.5835 30.5033 17.4167 30.0833 17.4167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.fb3a672e03bd13238256cdc89fb9aeaa.svg";
export { ForwardRef as ReactComponent };